import { BrowserRouter, Route, RouteComponentProps } from 'react-router-dom'
import { useMemo } from 'react'

import reactComponentLoader from 'scripts/react-component-loader'

import { AlgoliaInstantSearch } from 'shared/contexts/AlgoliaInstantSearch'
import { indexName } from 'shared/contexts/AlgoliaInstantSearch/lib'

import { AlgoliaEntryKey } from '.'
import { Header } from '../NewHeader/entry'
import { AlgoliaContextProvider } from './context/algolia-context'

const EntryKeyApp = (dataset: any) => {
  const {
    personalizationTrack = '{}',
    apiData = null,
    debounceTimer,
    type,
    pageType,
    url,
    ...rest
  } = dataset

  const isSearchResultPage = useMemo(
    () => type === 'search' || type === 'mappedSearch' || type === 'entryKey',
    [type]
  )

  const algoliaContextProps = {
    pageType,
    type,
    baseUrl: url,
    isSearch: isSearchResultPage
  }

  return (
    <BrowserRouter>
      <Route
        component={(props: RouteComponentProps) => (
          <AlgoliaInstantSearch
            isSearchResultPage={isSearchResultPage}
            {...props}
          >
            <AlgoliaContextProvider {...algoliaContextProps}>
              <Header />

              <AlgoliaEntryKey
                personalizationTrack={JSON.parse(personalizationTrack)}
                apiData={JSON.parse(apiData)}
                isSearchResultPage={isSearchResultPage}
                indexName={indexName}
                {...rest}
              />
            </AlgoliaContextProvider>
          </AlgoliaInstantSearch>
        )}
      />
    </BrowserRouter>
  )
}

reactComponentLoader(EntryKeyApp, '[data-entry-key-algolia]')
